<template>
    <div>
      <p>Mid Price: {{ midPrice }}</p>
    <p>Execution Price: {{ executionPrice }}</p>
    <p>Next Mid Price: {{ nextMidPrice }}</p>
      
      <button @click="swap">Swap 2</button>
    </div>
  </template>
  
  <script>
  import { ChainId, Fetcher, WETH, Route, Trade, TokenAmount, TradeType, Percent } from '@uniswap/sdk';
  import { ethers } from 'ethers';
  
  
  
  export default {
    data() {
      return {
        midPrice: '',
        executionPrice: '',
        nextMidPrice: '',
      }
    },
    async created() {
      const chainId = ChainId.GÖRLI;
      const tokenAddress = '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984';
  
      const uni = await Fetcher.fetchTokenData(chainId, tokenAddress);
      const weth = WETH[chainId];
      const pair = await Fetcher.fetchPairData(uni, weth);
      const route = new Route([pair], weth);
      const trade = new Trade(route, new TokenAmount(weth, '10000000000000000000000000000000000'), TradeType.EXACT_INPUT);
  
      this.midPrice = route.midPrice.toSignificant(6);
      this.executionPrice = trade.executionPrice.toSignificant(6);
      this.nextMidPrice = trade.nextMidPrice.toSignificant(6);
    },
    methods: {
      async swap() {
        const chainId = ChainId.GÖRLI;
        const tokenAddress = '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984';
  
        const uni = await Fetcher.fetchTokenData(chainId, tokenAddress);
        const weth = WETH[chainId];
        const pair = await Fetcher.fetchPairData(uni, weth);
        const route = new Route([pair], weth);
        const trade = new Trade(route, new TokenAmount(weth, '1'), TradeType.EXACT_INPUT);
  
        const slippageTolerance = new Percent('50', '10000'); //50 bips 1 bip = 0.001
        const amountOutMin = trade.minimumAmountOut(slippageTolerance).raw;
        //const amountOutMinRaw = ethers.BigNumber.from(amountOutMin.raw.toString());
  
        console.log(`amtout----- ${amountOutMin}`);
  
  
        const path = [weth.address, uni.address];
        const to = '0x8547e1c14BE5F0C84870a0d796BeAaBeC77f86C9';
        const deadline = Math.floor(Date.now() / 1000) + 60 * 20;
        const value = trade.inputAmount.raw;
  
        
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        
        const signer = new ethers.Wallet(ethers.utils.hexlify('0x07f4f7b5782bee3f3a8f66351d54d4126047598e1667960fb7f26a4b40e49d1c'));
        const gasPrice = provider.getGasPrice();
  
        const account = signer.connect(provider);
        const uniswap = new ethers.Contract(
          '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
          ['function swapExactETHForTokens(uint amountOutMin, address[] calldata path, address to, uint deadline) external payable returns (uint[] memory amounts)'],
          account,
  
        );
        const tx = await uniswap.swapExactETHForTokens(
          String(amountOutMin),
          path,
          to,
          deadline,
          { value: String(value), gasPrice: gasPrice, gasLimit: 500000 }
        )
        console.log(`Transaction hash: ${tx.hash}`);
        const receipt = await tx.wait();
        console.log(`Transaction was mined in block ${receipt.blockNumber}`);
      },
    }
  };
  
  //sample transaction hash that failed 0x576eb18cb6226aa9dc753eef92acfd23d2092b012228a5f92a1778c6d0c9cad2 
  </script>
  
  <style>
p {
  color: black;
}
</style>
